export default "__VITE_ASSET__SNVAOxuc__"